import { BRONZE, GOLD, SILVER } from '../styles/theme';

export const PRIME_COLOR_MAP: { [key: string]: string } = {
  GOLD,
  SILVER,
  BRONZE,
};

export const PRIME_BG_COLOR_MAP: { [key: string]: string } = {
  GOLD: '#f6eddc',
  SILVER: '#eff0f9',
  BRONZE: '#f6efea',
};
